import { render, staticRenderFns } from "./ResIndex.vue?vue&type=template&id=bcb181c4&scoped=true"
import script from "./ResIndex.vue?vue&type=script&lang=js"
export * from "./ResIndex.vue?vue&type=script&lang=js"
import style0 from "./ResIndex.vue?vue&type=style&index=0&id=bcb181c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb181c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcb181c4')) {
      api.createRecord('bcb181c4', component.options)
    } else {
      api.reload('bcb181c4', component.options)
    }
    module.hot.accept("./ResIndex.vue?vue&type=template&id=bcb181c4&scoped=true", function () {
      api.rerender('bcb181c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/res/ResIndex.vue"
export default component.exports